import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import projectsReducer from './slices/projectsSlice';
import votingReducer from './slices/votingSlice';
import commentsReducer from './slices/commentsSlice';
import chatReducer from './slices/chatSlice';
import videoReducer from './slices/videoSlice';
import websocketReducer from './slices/websocketSlice';
import kycReducer from './slices/kycSlice';
import reputationReducer from './slices/reputationSlice';
import loyaltyReducer from './slices/loyaltySlice';
import uiReducer from './slices/uiSlice';
import notificationsReducer from './slices/notificationsSlice';
import goalsReducer from './slices/goalsSlice';
import milestonesReducer from './slices/milestonesSlice';
import themeReducer from './slices/themeSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    projects: projectsReducer,
    voting: votingReducer,
    comments: commentsReducer,
    chat: chatReducer,
    video: videoReducer,
    websocket: websocketReducer,
    kyc: kycReducer,
    reputation: reputationReducer,
    loyalty: loyaltyReducer,
    ui: uiReducer,
    notifications: notificationsReducer,
    goals: goalsReducer,
    milestones: milestonesReducer,
    theme: themeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['websocket/message'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

